import script from "./Account_Management.vue?vue&type=script&setup=true&lang=js"
export * from "./Account_Management.vue?vue&type=script&setup=true&lang=js"

import "./Account_Management.vue?vue&type=style&index=0&id=623d01b7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-623d01b7"]])

export default __exports__